// import React from 'react';
// import { EdgeProps, getBezierPath } from '@xyflow/react';

// const ConditionEdge: React.FC<EdgeProps> = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, markerEnd, data }) => {
//   const [edgePath, labelX, labelY] = getBezierPath({ sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition });

//   return (
//     <>
//       {/* Edge Path */}
//       <path id={id} d={edgePath} stroke="#888" strokeWidth={2} fill="none" markerEnd={markerEnd} />

//       {/* Label for True/False Edges */}
//       {data?.label && (
//         <foreignObject x={labelX - 20} y={labelY - 10} width="60" height="20">
//           <div
//             style={{
//               fontSize: '12px',
//               color: data.label === 'is true' ? '#4caf50' : '#f44336',
//               background: '#fff',
//               padding: '2px 6px',
//               borderRadius: '6px',
//               fontWeight: 'bold',
//               textAlign: 'center'
//             }}
//           >
//             {data.label as string}
//           </div>
//         </foreignObject>
//       )}
//     </>
//   );
// };

// export default ConditionEdge;

import React from 'react';
import { EdgeProps, getBezierPath } from '@xyflow/react';

const ConditionEdge: React.FC<EdgeProps> = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, markerEnd, data }) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });

  return (
    <>
      {/* Main Edge Path */}
      <path id={id} d={edgePath} stroke="#888" strokeWidth={2} fill="none" markerEnd={markerEnd} />

      {/* Label for Conditional Branches */}
      {data?.label && (
        <foreignObject x={labelX - 30} y={labelY - 10} width="80" height="20">
          <div
            style={{
              fontSize: '12px',
              color: '#fff',
              background: data.label === 'is true' ? '#4caf50' : '#f44336',
              padding: '4px 8px',
              borderRadius: '6px',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            {data.label as string}
          </div>
        </foreignObject>
      )}
    </>
  );
};

export default ConditionEdge;
